import axios from 'axios';

export default axios.create({
  baseURL: `https://www.youvegotthepower.nl/game/api`
});



// WEBPACK FOOTER //
// ./src/functions/api.js